import { Grid, Typography, makeStyles } from "@material-ui/core";
import React from "react";
import GuideComponent from "../../../components/materialui/Shared/GuideComponent"
import GuideIMG from "../../../../assets/guide.png";


const useStyles = makeStyles(() => ({

    message: {
        fontSize: '1em',
        color: '#000',
        fontWeight: 'lighter',
    },

    documentItem: {
        fontSize: '0.8em',
        color: '#231F20',
        font: 'Inter',
        fontWeight: 'lighter',
    },

    image: {
        width: '40%',
        display: "block",
        margin: "0 auto"
    },
}));


export default function GuideStep() {

    const classes = useStyles();

    return (
        <div>
            <GuideComponent title="Guia de documentação">
                <Grid container spacing={2}>

                    <Grid item xs={12}>
                        <Grid container>
                            <Grid item sm={12}>
                                <img src={GuideIMG} className={classes.image} alt="Imagem ilustrativa de um guia" />
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body1" className={classes.message}>
                            Antes de iniciar o preenchimento do formulário, tenha em mãos os seguintes documentos que deverão ser anexados a solicitação:
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Typography variant="body2" component="span" className={classes.documentItem}>
                            <p> - Certidão de Ética Profissional (emitir pelo site do CREMESP); </p>
                            <p> - Certidão de Quitação (emitir pelo site do CREMESP); </p>
                            <p> - Comprovante de Vacinação COVID19; </p>
                            <p> - Cópia da carteira do Conselho ; </p>
                            <p> - Cópia do Diploma Graduação em Medicina <strong>(Frente e Verso);</strong></p>
                            <p> - Cópia do RG;  </p>
                            <p> - Cópia do Título de Especialista ou Residência Médica <strong>(Frente e Verso)</strong>
                                - (Mínimo 2 anos da data de conclusão);  </p>
                            <p> - Currículo resumido atualizado; </p>
                            <p> - Uma foto digital fundo branco; </p>
                        </Typography>
                    </Grid>
                </Grid>
            </GuideComponent>
        </div>

    )
}